import React from 'react';
import { Button } from './ui/button';
import { CheckCircle2, Target, Shield } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold text-white">
                About <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">FrostByte IT</span>
              </h2>
              <p className="text-xl text-slate-300 leading-relaxed">
                At FrostByte IT, dedication means delivering right-sized IT solutions for both home users and businesses.
              </p>
            </div>

            <div className="space-y-6">
              <p className="text-lg text-slate-400 leading-relaxed">
                With over 15 years of experience, we keep your technology reliable, secure, and working the way you need it to. We provide managed services including router and Wi-Fi access point setup, computer repair, new network installation, security camera installation and monitoring, smart home configuration, and security-focused solutions to protect your data and devices.
              </p>
            </div>

            {/* Key Points */}
            <div className="space-y-4 pt-4">
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-white font-semibold mb-1">Right-Sized Solutions</h4>
                  <p className="text-slate-400">Tailored IT services that match your specific needs and budget</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-white font-semibold mb-1">15+ Years Experience</h4>
                  <p className="text-slate-400">Proven track record of delivering reliable IT solutions</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-white font-semibold mb-1">Security Focused</h4>
                  <p className="text-slate-400">Comprehensive data protection and security measures</p>
                </div>
              </div>
            </div>

            <Button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-lg transition-all duration-300 shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50"
            >
              Let's Work Together
            </Button>
          </div>

          {/* Right Column - Stats */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-slate-950/50 p-8 rounded-2xl border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 backdrop-blur-sm">
              <Target className="w-10 h-10 text-cyan-400 mb-4" />
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-slate-400">Client Satisfaction</div>
            </div>
            <div className="bg-slate-950/50 p-8 rounded-2xl border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 backdrop-blur-sm">
              <CheckCircle2 className="w-10 h-10 text-cyan-400 mb-4" />
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-slate-400">Support Available</div>
            </div>
            <div className="bg-slate-950/50 p-8 rounded-2xl border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 backdrop-blur-sm col-span-2">
              <Shield className="w-10 h-10 text-cyan-400 mb-4" />
              <div className="text-4xl font-bold text-white mb-2">Trusted</div>
              <div className="text-slate-400">Security & Reliability</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;